import { type UseQueryOptions, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import type { Session } from '@cobliteam/common-types';

import { SessionManager } from '@cobliteam/api-lib';

import { Environment } from '@cobliteam/react-environments';

const env = Environment.getInstance().getEnvironment();
const sessionManager = new SessionManager({ host: env.herbieApiHost });

export const QUERY_KEY = 'LOGIN';
export const QUERY_KEY_SSO_TOKEN = 'SSO_TOKEN';

const useLogin = () => {
  const queryClient = useQueryClient();
  queryClient.clear();
  return useMutation<Session, unknown, { username: string; password: string }>({
    mutationFn: ({ username, password }) => sessionManager.login(username, password),
  });
};

const useGetHubSpotSSOToken = (options?: Partial<UseQueryOptions<string>>) => {
  return useQuery<string>({
    queryKey: [QUERY_KEY, QUERY_KEY_SSO_TOKEN],
    queryFn: () => sessionManager.getHubSpotSSOToken(),
    ...options,
  });
};

export { useLogin, useGetHubSpotSSOToken };
export default QUERY_KEY;
